import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MoaksBmlScoringModel} from '../../../../../_models/MOAKS/moaks-bml-scoring-model';
import {MoaksVisitModel} from '../../../../../_models/MOAKS/moaks-visit-model';
import { SharedService } from '../../moaks-basic-form/shared.service';

@Component({
    selector: 'app-moaks-bml-scoring-form',
    templateUrl: './moaks-bml-scoring-form.component.html',
    styleUrls: ['./moaks-bml-scoring-form.component.css']
})
export class MoaksBmlScoringFormComponent implements OnInit, OnDestroy {

    scoreOrder = [ 'MP', 'LP', 'MAF', 'MCF', 'MPF', 'MAT', 'MCT', 'MPT', 'LAF', 'LCF', 'LPF', 'LAT', 'LCT', 'LPT', 'ST' ];
    _bmlSizes = ['0', '1', '2', '3', 'U'];
    _bmlSizesMocart = ['0', '1', '2', '3', 'U', '+0.5', '-0.5'];
    bmlSizes = this._bmlSizes;
    bmlPercents = ['0', '1', '2', '3', 'U'];
    form: FormGroup;
    tableDataSource: MatTableDataSource<MoaksBmlScoringModel>;
    tableColumns = ['Name', 'Size', 'Num', 'Percent'];
    @Input()
    get visit(): MoaksVisitModel { return this._visit; }
    set visit(visit: MoaksVisitModel) {
        this._visit = visit;
        if (this.form) { // ngOnInit() will init first time
          this.init();
        }
    }
    private _visit: MoaksVisitModel;

    @Input() uid: string;
    @Input() isMocart: boolean;

    constructor(
        private fb: FormBuilder,
        private sharedService: SharedService
    ) {
    }

    ngOnInit(): void {
        this.tableDataSource = new MatTableDataSource<MoaksBmlScoringModel>();
        const scoringFormControl = this.fb.array([]);
        this._visit.bmlScorings.forEach((scoring) => {
            scoringFormControl.push(this.fb.group({
                id: ['', [Validators.required]],
                code: ['', [Validators.required]],
                region: ['', [Validators.required]],
                size: ['', [Validators.required]],
                num: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
                percent: ['', [Validators.required]]
            }));
        });
        this.form = this.fb.group({
            scorings: scoringFormControl
        });
        this.init();
        this.fillEmptyCellsWithZero();

        this.sharedService.sync(this.uid, (rowIndex, valueName, value) => {
          this._visit.bmlScorings[rowIndex][valueName] = value;
          if ((valueName === 'size' || valueName === 'num' || valueName === 'percent') && this.form) {
            (this.form.get('scorings') as FormArray).controls[rowIndex].get(valueName).setValue(value);
          }
        })
    }

    ngOnDestroy(): void {
        this.setSubmitData();
        this.sharedService.messageSource.next(null);
    }


    init(): void {
        
        this.tableDataSource.data = this._visit.bmlScorings;

        this.bmlSizes = this.isMocart ? this._bmlSizesMocart : this._bmlSizes;
        let index = 0;
        ((this.form.get('scorings') as FormArray).controls as FormGroup[]).forEach(formGroup => {
            const scoring = this.tableDataSource.data[index];
            formGroup.get('id').setValue(scoring.id);
            formGroup.get('code').setValue(scoring.code);
            formGroup.get('region').setValue(scoring.region);
            formGroup.get('size').setValue(scoring.size);
            formGroup.get('num').setValue(scoring.num);
            formGroup.get('percent').setValue(scoring.percent)
            if (this.shouldDisable()) {
              formGroup.disable();
            }
            index++;
        });
    }

    shouldDisable(){
      return (this._visit.status ||'') .toLowerCase() === 'done';
    }

    fillEmptyCellsWithZero(): void {
        ((this.form.get('scorings') as FormArray).controls as FormGroup[]).forEach(formGroup => {
            if (!formGroup.get('size').value) {
                formGroup.get('size').setValue('0');
            }
            if (!formGroup.get('num').value) {
                formGroup.get('num').setValue(0);
            }
            if (!formGroup.get('percent').value) {
                formGroup.get('percent').setValue('0');
            }

        });
    }

    reset(): void {
        ((this.form.get('scorings') as FormArray).controls as FormGroup[]).forEach(formGroup => {
            formGroup.get('size').reset();
            formGroup.get('num').reset();
            formGroup.get('percent').reset();
            formGroup.get('id').reset();
            formGroup.get('code').reset();
            formGroup.get('region').reset();
        });
    }

    setSubmitData(): void {
        ((this.form.get('scorings') as FormArray).controls as FormGroup[]).forEach(formGroup => {
            const scoring = this._visit.bmlScorings.find(value => value.id === formGroup.get('id').value);
            scoring.percent = formGroup.get('percent').value;
            scoring.num = formGroup.get('num').value;
            scoring.size = formGroup.get('size').value;
        });
    }

    duplicateValue(rowIndex, item) {
      this.setSubmitData();
      const uidIndex = this.uid.replace(/\D+/g, '');
      const val = this._visit.bmlScorings[rowIndex][item];
      this.sharedService.messageSource.next([rowIndex, item, val, uidIndex]);
    }
}
